<template>
  <div class="column is-6">
    <p>Expenses chart</p>
  </div>
</template>

<script>
export default {
  name: 'ExpensesAndAverageExpensesChart',
};
</script>

<style scoped>

</style>
